import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import { API_REQUEST } from '@/api/'; // mutation

export var setVacancies = function setVacancies(state, value) {
  state.vacancies = value;
}; // action

export var updateVacancies = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _res$;

    var rootGetters, getters, commit, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rootGetters = _ref.rootGetters, getters = _ref.getters, commit = _ref.commit;
            _context.next = 3;
            return API_REQUEST('getVacancies', {
              'shop_id': rootGetters['queryMirrored/getOneDep'],
              'dt_from': getters['visibleDates'][0],
              'dt_to': getters['visibleDates'].slice(-1)[0],
              'offset': 0,
              'limit': 100000
            });

          case 3:
            res = _context.sent;

            if ((_res$ = res[1]) !== null && _res$ !== void 0 && _res$.results) {
              commit('setVacancies', res[1].results);
            }

            return _context.abrupt("return", Boolean(res));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateVacancies(_x) {
    return _ref2.apply(this, arguments);
  };
}(); // getter

export var vacancies = function vacancies(state, getters, rootState, rootGetters) {
  // const tableCellParts = state.tableCellParts
  var vacanciesRaw = state.vacancies || [];
  var result = vacanciesRaw.reduce(function (accumulator, current) {
    // const currentViewStr = ['PLAN', 'FACT'][Number(current['is_fact'])] +
    //   '_' + ['UNAPPR', 'APPR'][Number(current['is_approved'])]
    // if (currentViewStr === tableCellParts[0]) {
    var date = current['dt'];

    if (date) {
      if (!accumulator[date]) accumulator[date] = [];
      accumulator[date].push(current);
    } // }


    return accumulator;
  }, {});
  return result;
};